import { WoWRace } from '@/types/apiServerContract';

export const WoWRaceMap = new Map([
    [WoWRace.RACE_HUMAN, { name: 'HUMAN', color: '#C79C6E' }],
    [WoWRace.RACE_ORC, { name: 'ORC', color: '#F58CBA' }],
    [WoWRace.RACE_DWARF, { name: 'DWARF', color: '#ABD473' }],
    [WoWRace.RACE_NIGHT_ELF, { name: 'NIGHT ELF', color: '#F8C621' }],
    [WoWRace.RACE_UNDEAD, { name: 'UNDEAD', color: '#A330C9' }],
    [WoWRace.RACE_TAUREN, { name: 'TAUREN', color: '#C41F3B' }],
    [WoWRace.RACE_GNOME, { name: 'GNOME', color: '#0070DE' }],
    [WoWRace.RACE_TROLL, { name: 'TROLL', color: '#40C7EB' }],
    [WoWRace.RACE_GOBLIN, { name: 'GOBLIN', color: '#8787ED' }],
    [WoWRace.RACE_BLOOD_ELF, { name: 'BLOOD ELF', color: '#8787ED' }],
    [WoWRace.RACE_DRAENEI, { name: 'DRAENEI', color: '#FF7D0A' }],
    [WoWRace.RACE_WORGEN, { name: 'WORGEN', color: '#FF7D0A' }]
]);

export const GetRaceColor = (raceId: WoWRace) => {
    const race = WoWRaceMap.get(raceId);
    return race ? race.color : '';
};

export const GetRaceName = (raceId: WoWRace) => {
    const race = WoWRaceMap.get(raceId);
    return race ? race.name : '';
};
